module.exports = __webpack_public_path__ + "static/media/double-sea.80162b43.jpg";